
export const clearSelectData = (payload) => {
    return{
        type:"CLEAR_SELECT_DATA",
        data:payload
    }
}

export const getDishes = (payload) => {
    return{
        type:"GET_DISHES_DATA",
        data:payload
    }
}

export const getMoreDishes = (payload) => {
    return{
        type:"GET_MORE_DISHES",
        data:payload
    }
}


export const selectDish = (payload) => {
    return{
        type:"SELECT_DISH",
        data:payload
    }
}

export const getDishData = (payload) => {
    return{
        type:"GET_DISH",
        data:payload
    }
}

export const updateDish = (payload) => {
    return{
        type:"UPDATE_DISH_DATA",
        data:payload
    }
}

export const addTagOnDish = (payload) => {
    return{
        type:"ADD_TAG",
        data:payload
    }
}

export const removeTagOfDish = (payload) => {
    return{
        type:"REMOVE_TAG",
        data:payload
    }
}

export const addImagePathOnDish = (payload) => {
    return{
        type:"ADD_IMAGE_PATH",
        data:payload
    }
}

export const removeImagePathOfDish = (payload) => {
    return{
        type:"REMOVE_IMAGE_PATH",
        data:payload
    }
}

export const getRecipes = (payload) =>  {
    return{
        type:"GET_RECIPES_DATA",
        data:payload
    }
}

export const getMoreRecipes = (payload) =>  {
    return{
        type:"GET_MORE_RECIPES_DATA",
        data:payload
    }
}

export const selectRecipe = (payload) => {
    return{
        type:"SELECT_RECIPE",
        data:payload
    }
}

export const getRecipeData = (payload) => {
    return{
        type:"GET_RECIPE",
        data:payload
    }
}

export const updateRecipe = (payload) => {
    return{
        type:"UPDATE_RECIPE_DATA",
        data:payload
    }
}

export const getIngredients = (payload) => {
    return{
        type:"GET_INGREDIENTS_DATA",
        data:payload
    }
}

export const getMoreIngredients = (payload) => {
    return{
        type:"GET_MORE_INGREDIENTS_DATA",
        data:payload
    }
}

export const selectIngredient = (payload) => {
    return{
        type:"SELECT_INGREDIENT",
        data:payload
    }
}

export const getIngredientData = (payload) => {
    return{
        type:"GET_INGREDIENT",
        data:payload
    }
}

export const updateIngredient = (payload) => {
    return{
        type:"UPDATE_INGREDIENT_DATA",
        data:payload
    }
}

export const changeEditMode = (payload) => {
    return{
        type:"CHANGE_EDIT_MODE",
        data:payload
    }
}

export const updatePayload = (payload) => {
    return{
        type:"UPDATE_PAYLOAD",
        data:payload
    }
}

export const setInitialPayload = (payload) => {
    return {
        type:"SET_INITIAL_PAYLOAD",
        data:payload
    }
}

export const setInitialObjectToEdit = (payload) => {
    return {
        type:"SET_INITIAL_OBJECT_EDIT",
        data:payload,
    }
}